var map = {
	"./add-image.svg": 407,
	"./angle-arrow-down.svg": 109,
	"./arrows.png": 26,
	"./btn-background.png": 27,
	"./button-down.png": 408,
	"./button-up.png": 409,
	"./chosen-balls-background.png": 39,
	"./coins.png": 410,
	"./delete-purple.png": 15,
	"./delete-white.png": 14,
	"./dog-racing.png": 188,
	"./fast-betting-btn-purple.png": 4,
	"./fast-betting-btn.png": 1,
	"./fast-btn-down.png": 8,
	"./fast-btn-up.png": 9,
	"./fast-coin.png": 411,
	"./fast-ticket-bck.png": 41,
	"./fullscreen.svg": 412,
	"./game-holder-bar.png": 413,
	"./green-btn-background.png": 414,
	"./grey-bck.png": 23,
	"./header-fast.png": 16,
	"./horse-racing.png": 189,
	"./hr-blue-btn.png": 3,
	"./hr-disabled-btn.png": 10,
	"./hr-grey-btn.png": 2,
	"./hr-red-btn.png": 18,
	"./log-in.png": 415,
	"./lucky-balls.png": 416,
	"./lucky-greek.png": 417,
	"./menu-active-background.png": 418,
	"./menu-right.svg": 419,
	"./red-btn-background.png": 13,
	"./rubbish-blue.svg": 420,
	"./rubbish-red-blue.svg": 421,
	"./rubbish-red.svg": 422,
	"./rubbish.svg": 423,
	"./send-message.svg": 424,
	"./share.svg": 425,
	"./slip-arrow-down.png": 426,
	"./slip-arrow-up.png": 427,
	"./ticket-background-light.png": 428,
	"./ticket-background.png": 429,
	"./tutorial-arrow-left.png": 430,
	"./tutorial-arrow-right.png": 431,
	"./up-arrow.svg": 110,
	"./video-roulette.png": 432,
	"./virtual-football-league.png": 433,
	"./virtual-football.png": 434
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 47;


//////////////////
// WEBPACK FOOTER
// ./src/ui/img \.(gif|png|jpe?g|svg)$/
// module id = 47
// module chunks = 11